module.exports = __webpack_public_path__ + "media/acuity/locus_logo-3df69e45.png";